import { IS_DEBUG } from './BrunchCheck';

const getLogStyle = (code) => {
    const style = 'padding: 4px 8px;';

    if (code >= 200 && code < 300) {
        return `${style} background: #C2E0C6; color: #000000;`;
    }

    if (code >= 400 && code < 600) {
        return `${style} background: #FEF0F0; color: #FF0000;`;
    }

    return `${style} background: #FEF2C0; color: #000000;`;
};

export const log = (message, code = 0) => {
    if (!IS_DEBUG) {
        return;
    }

    console.log(`%c${message}`, getLogStyle(code));
};

const paramsToUrl = (params = {}) => {
    const keyList = Object.keys(params);

    if (!keyList.length) {
        return '';
    }

    return `?${keyList
        .map((key) => `${key}=${params[key]}`)
        .join('&')}`;
};

export const logAjaxRequest = (config) => {
    if (!IS_DEBUG) {
        return;
    }

    const { url, method, params, data } = config;
    const urlParams = paramsToUrl(params);

    console.groupCollapsed(`%c[REQUEST][${method.toUpperCase()}] ${url}${urlParams}`, getLogStyle(0));
    console.log('>>> config', config);
    params && console.log('>>> params', params);
    data && console.log('>>> data', data);
    console.groupEnd();
};

export const logAjaxResponse = (response) => {
    if (!IS_DEBUG) {
        return;
    }

    const { data, config: { url, metadata, method, params } } = response;
    const spendTime = new Date().getTime() - metadata.startTime;
    const urlParams = paramsToUrl(params);
    const groupTitle = `[${method.toUpperCase()}][${data.code}][${spendTime}ms] ${url}${urlParams}`;

    console.groupCollapsed(`%c${groupTitle}`, getLogStyle(data.code));
    console.log('>>> response', response);
    params && console.log('>>> params', params);

    if (data.code !== 200) {
        console.log('>>> data', data);
    } else {
        console.log('>>> data', data.data);
    }

    console.groupEnd();
};
